/** A supported display currency and the static rate used to convert from USD. */
export interface CurrencyOption {
  /** ISO 4217 currency code, e.g. "USD". */
  code: string
  /** BCP 47 locale used for number grouping when formatting. */
  locale: string
  /** Human-readable label shown in the picker. */
  label: string
  /** Emoji flag representing the currency's country/region. */
  flag: string
  /** Static conversion rate relative to 1 USD (display-only approximation). */
  rate: number
}

/** Currencies offered in the selector. Rates are static approximations. */
export const CURRENCY_OPTIONS: CurrencyOption[] = [
  { code: 'USD', locale: 'en-US', label: 'US Dollar', flag: '🇺🇸', rate: 1 },
  { code: 'CAD', locale: 'en-CA', label: 'Canadian Dollar', flag: '🇨🇦', rate: 1.37 },
]

/** Currency selected by default before the user picks one. */
export const DEFAULT_CURRENCY_CODE = 'USD'
